@for (link of hamburgerLinks(); track link) {
  <div
    class="hamburger-link"
    [ngClass]="{
      'hamburger-link--border': !link.submenu,
      'hamburger-link--mobile': !link.desktopView,
      'hamburger-link--parent-submenu': !!link.submenu,
    }"
    [routerLink]="link.route ? link.route : null"
    [fragment]="link.fragment"
    nz-menu-item
    (click)="!link.submenu && onMenuItemClick()"
  >
    <span class="item-label-container">
      {{ link.name | translate }}
      @if (link.badgeValue) {
          <nz-badge nzStandalone [nzCount]="link.badgeValue"></nz-badge>
      }
    </span>
  </div>
  @for (subLink of link.submenu; track subLink; let last = $last) {
    <div
      class="hamburger-link--submenu-link"
      [ngClass]="{
        'hamburger-link--mobile': !subLink.desktopView,
        'hamburger-link--submenu-last': last,
      }"
      [routerLink]="subLink.route ? subLink.route : null"
      [fragment]="subLink.fragment"
      nz-menu-item
      (click)="!subLink.submenu && onMenuItemClick()"
    >
      {{ subLink.name | translate }}
    </div>
  }
}
<div class="logout-btn">
  <span nz-menu-item>
    <liberro-button
      [danger]="true"
      [label]="'header.hamburgerLinks.logOut' | translate"
      (click)="logout()"
    ></liberro-button>
  </span>
</div>

